import { render, staticRenderFns } from "./ActivityIntroduction.vue?vue&type=template&id=55a003fe&scoped=true&"
import script from "./ActivityIntroduction.vue?vue&type=script&lang=js&"
export * from "./ActivityIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./ActivityIntroduction.vue?vue&type=style&index=0&id=55a003fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a003fe",
  null
  
)

component.options.__file = "ActivityIntroduction.vue"
export default component.exports